import {ScheduledStop} from '../api/types/types';

const scheduledStopCache = new Map<string, Array<ScheduledStop>>();

export {scheduledStopCache};
